import React from 'react'

export function NavBarMobile(props) {
  return (
    <div id="navbarBasicExample" className="navbar-menu">
      <div className="navbar-start">
        <a className="navbar-item">Home</a>
        <a className="navbar-item">Documentation</a>
        <div className="navbar-item has-dropdown is-hoverable">
          <a className="navbar-link">More</a>
          <div className="navbar-dropdown">
            <a className="navbar-item">About</a>
            <a className="navbar-item">Jobs</a>
            <a className="navbar-item">Contact</a>
            <a className="navbar-item">Report an issue</a>
          </div>
        </div>
      </div>
      <div className="navbar-end">
        <div className="navbar-item">
          <div className="field is-grouped">
            <p className="control">
              <a
                className="bd-tw-button button"
                data-social-network="Twitter"
                data-social-action="tweet"
                data-social-target="https://bulma.io"
                target="_blank"
                href="https://twitter.com/intent/tweet?text=Bulma: a modern CSS framework based on Flexbox&amp;hashtags=bulmaio&amp;url=https://bulma.io&amp;via=jgthms"
                rel="noreferrer"
              >
                <span className="icon">
                  <i className="fab fa-twitter"></i>
                </span>
                <span>Tweet</span>
              </a>
            </p>
            <p className="control">
              <a
                className="button is-primary"
                href="https://github.com/jgthms/bulma/releases/download/0.9.4/bulma-0.9.4.zip"
              >
                <span className="icon">
                  <i className="fas fa-download"></i>
                </span>
                <span>Download</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
